import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { Observable, scan } from 'rxjs';
import { NavigationDetails } from '../../core/services/navigation.service';
import { map, share } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'ssc-selection-navigation-bar',
  templateUrl: './selection-navigation-bar.component.html',
  styleUrls: ['./selection-navigation-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectionNavigationBarComponent implements AfterViewInit {
  @Input()
  public previousButtonNavigationDetails: NavigationDetails;
  @Input()
  public nextButtonNavigationDetails: NavigationDetails;

  public fixedNavigationBarShouldBeVisible$: Observable<boolean>;
  public fixedNavigationBarShouldAnimate$: Observable<boolean>;

  @ViewChild('navigationBar') private navigationBar: ElementRef;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  public ngAfterViewInit(): void {
    this.fixedNavigationBarShouldBeVisible$ = new Observable<boolean>((subscriber) => {
      const observer = new IntersectionObserver(([entry]) => subscriber.next(!entry.isIntersecting), {
        threshold: [0, 1],
      });
      observer.observe(this.navigationBar.nativeElement);

      return () => {
        observer.disconnect();
      };
    }).pipe(share());
    // only animate if state changes after initial page load
    this.fixedNavigationBarShouldAnimate$ = this.fixedNavigationBarShouldBeVisible$.pipe(
      scan((acc) => acc + 1, 0),
      map((count) => count > 1),
    );

    this.changeDetectorRef.markForCheck();
  }
}
